import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import { TranslatorService } from '../../../services/translator_service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-logout-validation',
  imports: [TranslatePipe, RTLDivDirectiveDirective,MatDialogModule],
  templateUrl: './logout-validation.html',
  styleUrl: './logout-validation.scss',
})
export class LogoutValidation {
  translationsObj;
	currentLang;
  constructor(private translator: TranslatorService) {
    this.translator.currentLangEmitter$
    .subscribe(async value=>{						
      this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
      this.currentLang = value;	 
    })
   }

  ngOnInit() {
  }
}
